import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime.js';
import cn from 'classnames';
import styles from './TextArea.module.css.js';

var TextArea = function TextArea(props) {
  var _cn;
  return jsxs(Fragment, {
    children: [jsx("textarea", {
      className: cn(styles.qdTextarea, props.className, (_cn = {}, _defineProperty(_cn, styles.invalid, props.invalid), _defineProperty(_cn, styles.resizable, props.resizable), _cn)),
      disabled: props.disabled,
      id: props.id || '',
      name: props.controlName,
      placeholder: props.placeholder,
      value: props.value,
      onChange: props.onChange
    }), jsx("div", {
      className: styles.error,
      children: props.error || null
    })]
  });
};

export { TextArea };
